export const ccModalGetStartedText = 'Get started today.';
export const promoPurchaseAmountText = `Amount Financed`;
export const promoPeriodText = `Promotional Period`;
export const applynowBtnText = 'Apply now';
export const applyNow = 'applyNow';
export const syfImgAltText = 'Synchrony Logo';
// Attributes for special Financing conditions
export const monthlyCostAmountTextPerMonth = '/MO'; // Text for monthly cost amount on credit card section per month
export const synchronyFinancingAlternateLabel: string =
  'Buy now. Pay over time.';
export const TYPES = {
  CREDIT_CARD: 'Visa',
  PAYPAL: 'Paypal',
  SYNCHRONY: 'Synchrony',
  APPLEPAY: 'ApplePay',
  PROGRESIVE: 'Progresive',
  AFFIRM: 'Affirm',
  DELETE_TRANSACTION: 'Progressive',
  CHECKOUT: 'Checkout',
  IS_CREDIT_CARD_VALID: 'usaEpayValid',
  CREDIT_CARDS_ARRAY: ['visa', 'mastercard', 'amex', 'discover', 'card'],
  ADYEN: 'VI',
};
export const SYNCHRONY_DETAILS = {
  SUGGESTED_PAYMENT: 'Suggested payments with',
  DEFAULT_TENDER_TYPE: '106',
  TOTAL_COST_PURCHASE_AMOUNT: 'Total cost including 2% promo fee',
  OFFER_VALID_UNTIL: '*offer valid until',
};
export const QUALIFYING_OFFER =
  'Your purchase qualifies for the following offer:';

export const prequalifyText = `See if you prequalify with no impact to your credit score.`;

export const WMAP_PREFIX = 'wmap-form';
export const MINIMUM_FINANCING_AMOUNT = 180;

export const getBalanceErrorMessages = (additionalAmount?: string) => ({
  otherAmountSelected: {
    title: 'Financing available for Balance only.',
    description:
      'Please select to pay "Balance" in Amount To Pay above to select financing option.',
  },
  belowMinimumAmount: {
    title: additionalAmount
      ? `Add ${additionalAmount} more to unlock additional financing options`
      : 'Add $## more to unlock additional financing options',
    description: '',
  },
});
export const BILLING_ADDRESS_WARNING = {
  title: 'Billing Information Required',
  description: 'Please add your billing information to complete payment.',
};

/**
 * Get the typed value from string enum if it is present in it or undefined
 * @param e - string enum as a type
 * @param s - string value
 * @return enum type value or undefined if not found
 */
export function valueOfEnum<T>(
  e: { [s: string]: T },
  s: string | undefined,
): T | undefined {
  return Object.values(e).find((f) => s === f);
}

const cardIcons = [
  {
    title: 'mastercard',
    src: '/makeapayment/icons/payment-connector/mastercard.svg',
    altText: 'mastercard',
  },
  {
    title: 'visa',
    src: '/makeapayment/icons/payment-connector/visa.svg',
    altText: 'visa',
  },
  {
    title: 'amex',
    src: '/makeapayment/icons/payment-connector/american-express.svg',
    altText: 'amex',
  },
  {
    title: 'discover',
    src: '/makeapayment/icons/payment-connector/discover.svg',
    altText: 'discover',
  },
];

export const PAYMENT_OPTIONS = {
  Visa: {
    title: 'Credit/Debit card',
    images: cardIcons,
  },
  VI: {
    title: 'Credit/Debit card',
    images: cardIcons,
  },
  Synchrony: {
    title: 'Pay 18 monthly',
    images: [
      {
        src: '/makeapayment/icons/payment-connector/synchrony-logo.svg',
        title: 'Synchrony',
        altText: 'Synchrony',
      },
    ],
  },
  Progresive: {
    title: 'Lease-To-Own',
    images: [
      {
        src: '/makeapayment/icons/payment-connector/progressive-logo.svg',
        title: 'Progressive',
        altText: 'Progressive',
      },
    ],
  },
  Affirm: {
    title: 'Pay with Affirm',
    images: [
      {
        src: '/makeapayment/icons/payment-connector/affirm.svg',
        title: 'Affirm',
        altText: 'Affirm',
      },
    ],
  },
};
export const lowerCase = (value: string) => value.toLowerCase();
